import * as React from "react";
import moment from "moment";
import "./FacesheetPersonal.scss";
import {
    getValueOrWhitespace,
    getFormattedName,
    getFormattedAddress,
    isNullOrWhitespace,
} from "../../services/stringService";

export const FacesheetPersonal = ({ personal, tax }) => {
    const formattedPhoneNumber = isNullOrWhitespace(personal.primaryPhoneNumber.phoneNumber)
        ? ""
        : personal.primaryPhoneNumber.phoneNumber.replace(/\D+/g, "").replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    const alternatePhoneNumber = isNullOrWhitespace(
        personal.alternatePhoneNumbers.filter(x => x.phoneType === "").map(x => x.phoneNumber)[0]
    )
        ? ""
        : personal.alternatePhoneNumbers
              .filter(x => x.phoneType === "")
              .map(x => x.phoneNumber)[0]
              .replace(/\D+/g, "")
              .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    console.log(personal.alternatePhoneNumbers.filter(x => x.phoneType === "").map(x => x.phoneNumber)[0]);
    const altHomePhone = isNullOrWhitespace(
        personal.alternatePhoneNumbers.filter(x => x.phoneType === "Home").map(x => x.phoneNumber)[0]
    )
        ? ""
        : personal.alternatePhoneNumbers
              .filter(x => x.phoneType === "Home")
              .map(x => x.phoneNumber)[0]
              .replace(/\D+/g, "")
              .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    const altCellPhone = isNullOrWhitespace(
        personal.alternatePhoneNumbers.filter(x => x.phoneType === "Cell").map(x => x.phoneNumber)[0]
    )
        ? ""
        : personal.alternatePhoneNumbers
              .filter(x => x.phoneType === "Cell")
              .map(x => x.phoneNumber)[0]
              .replace(/\D+/g, "")
              .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    const altWorkPhone = isNullOrWhitespace(
        personal.alternatePhoneNumbers.filter(x => x.phoneType === "Work").map(x => x.phoneNumber)[0]
    )
        ? ""
        : personal.alternatePhoneNumbers
              .filter(x => x.phoneType === "Work")
              .map(x => x.phoneNumber)[0]
              .replace(/\D+/g, "")
              .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    return (
        <div className="facesheet-personal">
            <h4 className="facesheet-personal__name">
                {getFormattedName(personal.firstName, personal.middleInitial, personal.lastName, personal.suffix)}
            </h4>
            <div className="facesheet-personal__info">
                <div className="facesheet-personal__left">
                    <div className="facesheet-personal__info-item">
                        <span className="h5">DOB </span>
                        <span className="p-regular">{moment(personal.dob).format("MM.DD.YYYY")}</span>
                    </div>
                    <div className="facesheet-personal__info-item">
                        <span className="h5">SSN </span>
                        <span className="p-regular">
                            {isNullOrWhitespace(personal.ssn) ? "" : `xxx-xx-${personal.ssn.slice(-4)}`}
                        </span>
                    </div>
                    <div className="facesheet-personal__info-item">
                        <span className="p-regular">
                            <span className="h5">Phone </span>
                            {formattedPhoneNumber}
                        </span>
                    </div>
                    {alternatePhoneNumber && (
                        <div className="facesheet-personal__info-item">
                            <span className="p-regular">
                                <span className="h5">Alternate Phone </span>
                                {alternatePhoneNumber}
                            </span>
                        </div>
                    )}
                    {altHomePhone && (
                        <div className="facesheet-personal__info-item">
                            <span className="p-regular">
                                <span className="h5">Alt. Phone(Home) </span>
                                {altHomePhone}
                            </span>
                        </div>
                    )}
                    {altCellPhone && (
                        <div className="facesheet-personal__info-item">
                            <span className="p-regular">
                                <span className="h5">Alt. Phone(Cell) </span>
                                {altCellPhone}
                            </span>
                        </div>
                    )}
                    {altWorkPhone && (
                        <div className="facesheet-personal__info-item">
                            <span className="p-regular">
                                <span className="h5">Alt. Phone(Work) </span>
                                {altWorkPhone}
                            </span>
                        </div>
                    )}
                    <div className="facesheet-personal__info-item">
                        <span className="p-regular">
                            <span className="h5">Email </span>
                            {getValueOrWhitespace(personal.email)}
                        </span>
                    </div>
                    <div className="facesheet-personal__info-item">
                        <span className="p-regular">
                            <span className="h5">Language </span>
                            <span className="p-regular">{getValueOrWhitespace(personal.preferredLanguage)}</span>
                        </span>
                    </div>
                    <div className="facesheet-personal__info-item">
                        <span className="p-regular">
                            <span className="h5">Marital Status </span>
                            <span className="p-regular">{getValueOrWhitespace(personal.maritalStatus)}</span>
                        </span>
                    </div>
                    <div className="facesheet-personal__info-item">
                        <span className="p-regular">
                            <span className="h5">Gender </span>
                            <span className="p-regular">{getValueOrWhitespace(personal.gender)}</span>
                        </span>
                    </div>
                </div>
                <div className="facesheet-personal__right">
                    <div className="facesheet-personal__info-item">
                        <span className="p-regular">
                            <span className="h5">Citizenship </span>
                            <span className="p-regular">{personal.isUsCitizen ? "US Citizen" : "Non US Citizen"}</span>
                        </span>
                    </div>

                    {!personal.isUsCitizen && (
                        <div className="facesheet-personal__info-item">
                            <span className="p-regular">
                                <span className="h5">Immigration Status </span>
                                <span className="p-regular">{personal.immigrationStatus}</span>
                            </span>
                        </div>
                    )}
                    <div className="facesheet-personal__info-item">
                        <span className="p-regular">
                            <span className="h5">Address </span>
                            {getFormattedAddress(personal.address)}
                        </span>
                    </div>

                    {personal.isMailingAddressDifferent && (
                        <div className="facesheet-personal__info-item">
                            <span className="p-regular">
                                <span className="h5">Mailing Address </span>
                                {getFormattedAddress(personal.mailingAddress)}
                            </span>
                        </div>
                    )}
                    <div className="facesheet-personal__info-item">
                        <span className="p-regular">
                            <span className="h5">Will file taxes this year? </span>
                            <span className="p-regular">
                                {tax.find(e => e.personId === personal.personId)?.planToFileTaxes ? "Yes" : "No"}
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};
